import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { PurchasedLicensesInfo } from '../data/purchased-licenses-info';

@Component({
  selector: 'app-license-tracking',
  templateUrl: './license-tracking.component.html',
  styleUrls: ['./license-tracking.component.scss']
})
export class LicenseTrackingComponent extends BaseComponent implements OnInit {
  
  // Fixed organization ID for license tracking
  readonly organizationId: number = 422;

  ngOnInit() {
    // Component initialization - license data is now handled by org-license-details
  }

  isInternal(): boolean {
    return this.authService.isInternal();
  }
} 